<template>
    <div>
        <ui-modal
            ref="modal"
            :title="title + ' (' + documentCount + ')'"
            size="xlarge"
            dismiss-on="close-button esc"
            @open="isOpen = true"
            @hide="isOpen = false; $emit('closed')"
        >
                <document-management-pane
                    ref="documents"
                    v-if="isOpen"
                    :model-type="modelType"
                    :model-id="modelId"
                    :descriptions="descriptions"
                    :accept="accept"
                    :defaultType="defaultType"
                    :existingDocuments="existingDocuments"
                    :should-associate="shouldAssociate"
                    item-class="col-2"
                    no-save-button
                    @saved="afterSave"
                    @can-save="e => this.canSave = e"
                    @document-count="e => this.documentCount = e"
                >
                    <template v-slot:top-callout="slotProps">
                        <slot name="top-callout" v-bind="slotProps"></slot>
                    </template>
                    <template v-slot:left-hand-buttons="slotProps">
                        <slot name="left-hand-buttons" v-bind="slotProps"></slot>
                    </template>
                    <template v-slot:right-hand-buttons="slotProps">
                        <slot name="right-hand-buttons"></slot>
                    </template>
                    <template v-slot:thumbnail-buttons="slotProps">
                        <slot name="thumbnail-buttons" v-bind="slotProps"></slot>
                    </template>
                    <template v-slot:thumbnail-details="slotProps">
                        <slot name="thumbnail-details" v-bind="slotProps"></slot>
                    </template>
                    <template v-slot:thumbnail-info="slotProps">
                        <slot name="thumbnail-info" v-bind="slotProps"></slot>
                    </template>
                </document-management-pane>

                <div slot="footer">
                    <button
                        class="btn btn-primary"
                        @click="$refs.documents.save()"
                        :disabled="!canSave">
                        Save Changes
                    </button>
                </div>
        </ui-modal>
    </div>
</template>

<script>
    import DocumentManagementPane from "./DocumentManagementPane";
    import {DocumentTypes} from "../../classes/Api/Document";

    export default {
        props: { 
            title: { 
                type: String,
                default: 'Edit Vehicle Documents',
            }, 
            descriptions: {
                type: Array,
                default() {
                    return [];
                },
            },
            accept: {
                type: String,
                default: '*',
            },
            defaultType: {
                type: String,
                default: DocumentTypes.TYPE_OTHER,
            },
            modelType: {
                type: String,
                required: true
            },
            modelId: {
                type: [String, Number],
                required: true
            },
            existingDocuments: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            shouldAssociate: {
                type: Boolean,
                default: true
            }
        },
        components: { DocumentManagementPane },
        data() {
            return {
                canSave: true,
                isOpen: false,
                documentCount: 0,
            }
        },
        methods: {
            open() {
                this.$refs.modal.open()
            },
            afterSave(e) {
                this.$emit('saved', e)
                this.$refs.modal.close()
            }
        }
    }
</script>
